var render, staticRenderFns
import script from "./Tabs.vue?vue&type=script&lang=tsx&"
export * from "./Tabs.vue?vue&type=script&lang=tsx&"
import style0 from "./Tabs.vue?vue&type=style&index=0&id=5e37ee54&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e37ee54",
  null
  
)

export default component.exports